export const DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LANGUAGE;
export const DEFAULT_ADMIN_LOCALE = 'en';
